import { string } from 'yup';

import { getSchema } from '@utils/schemaUtils';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_250_LENGTH, MAX_1000_LENGTH } from '@constants/validationMessages';

export const basicInformationFields = {
	status: string()
		.required(),
	ruleName: string()
		.trim()
		.max(MAX_250_LENGTH, getMaxLengthErrMsg('Rule name', MAX_250_LENGTH))
		.required(validationErrMessages.ruleName),
	severity: string()
		.required(),
	ruleDescription: string()
		.nullable()
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Rule description', MAX_1000_LENGTH)),
};

export const basicInformationSchema = getSchema(basicInformationFields);
